"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestCacheControl = exports.IkeRestCacheBasic = exports.IkeRestCacheFactory = void 0;
exports.IkeRestCacheFactory = {
    create: function (obj) {
        return new IkeRestCacheBasic(obj);
    }
};
var IkeRestCacheBasic = /** @class */ (function () {
    function IkeRestCacheBasic(obj) {
        this.obj = obj;
        this.cache = {};
    }
    IkeRestCacheBasic.prototype.getKey = function (key, value) {
        if (this.obj.canCache(key)) {
            return "".concat(key, ":").concat(value);
        }
        throw new Error("Invalid cacheKey ".concat(this.obj.actionName, ":").concat(key));
    };
    IkeRestCacheBasic.prototype.get = function (key, value) {
        var internalKey = this.getKey(key, value);
        return this.cache[internalKey];
    };
    IkeRestCacheBasic.prototype.set = function (key, value, obj) {
        var internalKey = this.getKey(key, value);
        this.cache[internalKey] = obj;
    };
    IkeRestCacheBasic.prototype.has = function (key, value) {
        var internalKey = this.getKey(key, value);
        return this.cache[internalKey] != null;
    };
    return IkeRestCacheBasic;
}());
exports.IkeRestCacheBasic = IkeRestCacheBasic;
var IkeRestCacheControl = /** @class */ (function () {
    function IkeRestCacheControl() {
        this._caches = {};
    }
    IkeRestCacheControl.prototype.get = function (obj, key) {
        if (this._caches[obj.actionName] == null) {
            this._caches[obj.actionName] = exports.IkeRestCacheFactory.create(obj);
        }
        var cache = this._caches[obj.actionName];
        if (!obj.canCache(key)) {
            throw new Error("Cannot get one on non cached key: ".concat(obj.actionName, ".").concat(key));
        }
        return cache;
    };
    IkeRestCacheControl.prototype.clear = function (obj) {
        if (obj != null) {
            this._caches[obj.actionName] = null;
        }
        else {
            this._caches = {};
        }
    };
    return IkeRestCacheControl;
}());
exports.IkeRestCacheControl = IkeRestCacheControl;
//# sourceMappingURL=cache.js.map